export enum SystemModules {
	CONTACT = 1,
	COMPANY_OR_CUSTOMER = 2,
	OPPORTUNITY = 3,
	DATE_TIME = 7,
	APPROVAL = 8,
	ACTIVITY = 100,
	PRODUCTS = 4

}